// src/pages/QuotationView.js
import React from 'react';
import QuotationDetail from '../components/quotation/QuotationDetail';

function QuotationView() {
  return <QuotationDetail />;
}

export default QuotationView;
